import { render, staticRenderFns } from "./QuickInvoiceSideMenu.vue?vue&type=template&id=75fbca65"
import script from "./QuickInvoiceSideMenu.vue?vue&type=script&lang=js"
export * from "./QuickInvoiceSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports